/* REIM SKIN — Theme JS */
document.addEventListener('DOMContentLoaded',function(){
  // Scroll header
  var h=document.getElementById('reimHeader');
  if(h)window.addEventListener('scroll',function(){h.classList.toggle('scrolled',window.scrollY>40)},{passive:true});

  // Scroll animations
  if('IntersectionObserver' in window){
    var els=document.querySelectorAll('.reim-anim');
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.style.animationPlayState='running';obs.unobserve(e.target)}})
    },{rootMargin:'-60px',threshold:0.01});
    els.forEach(function(el){el.style.opacity='0';el.style.animationPlayState='paused';obs.observe(el)});
  }

  // Close mobile menu on click
  var mm=document.getElementById('reimMobileMenu');
  if(mm)mm.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mm.classList.remove('open')})});
});

// Brand search filter
function filterBrands(){
  var q=document.getElementById('brandSearch').value.toLowerCase();
  var cells=document.querySelectorAll('.reim-brand-cell');
  cells.forEach(function(c){c.style.display=c.textContent.toLowerCase().includes(q)?'':'none'});
}

// Journal functionality
function reimJournalKey(){
  var el=document.getElementById('reim-journal');
  return el?'reim-journal-'+el.dataset.customerId:'reim-journal';
}
function reimEsc(s){
  var d=document.createElement('div');
  d.textContent=s||'';
  return d.innerHTML;
}
function saveJournalEntry(){
  var t=document.getElementById('jTitle').value.trim();
  var m=document.getElementById('jMood').value;
  var n=document.getElementById('jNotes').value.trim();
  if(!t||!n)return;
  var entries=JSON.parse(localStorage.getItem(reimJournalKey())||'[]');
  var entry={id:Date.now().toString(),date:new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}),title:t,mood:m,content:n};
  entries.unshift(entry);
  localStorage.setItem(reimJournalKey(),JSON.stringify(entries));
  document.getElementById('jTitle').value='';
  document.getElementById('jNotes').value='';
  document.getElementById('jMood').value='Neutral';
  document.getElementById('journalForm').classList.add('reim-hidden');
  renderJournal();
}
function deleteJournalEntry(id){
  var entries=JSON.parse(localStorage.getItem(reimJournalKey())||'[]');
  entries=entries.filter(function(e){return e.id!==id});
  localStorage.setItem(reimJournalKey(),JSON.stringify(entries));
  renderJournal();
}
function renderJournal(){
  var c=document.getElementById('journalEntries');
  var emp=document.getElementById('journalEmpty');
  if(!c)return;
  var entries=JSON.parse(localStorage.getItem(reimJournalKey())||'[]');
  if(entries.length===0){c.innerHTML='';if(emp)emp.style.display='';return}
  if(emp)emp.style.display='none';
  c.innerHTML=entries.map(function(e){
  return '<div class="reim-journal-entry reim-anim"><div class="reim-journal-entry-header"><div><p class="reim-journal-entry-date">'+e.date+'</p><h3 class="reim-journal-entry-title">'+reimEsc(e.title)+'</h3></div><button class="reim-journal-delete" onclick="deleteJournalEntry(\''+e.id+'\')"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/></svg></button></div><div class="reim-journal-mood">'+reimEsc(e.mood)+'</div><p class="reim-journal-content">'+reimEsc(e.content)+'</p></div>';
  }).join('');
}
// Init journal on page load
document.addEventListener('DOMContentLoaded',function(){renderJournal()});